import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import { PreviewWrapperProps } from '@wix/editor-elements-types';
import {
  DatePickerPlatformProps,
  DatePickerDefinition,
} from '../DatePicker.types';
import { props as viewerPropsMapper } from './DatePicker.mapper';

const props = composeMapper<
  PreviewWrapperProps<DatePickerPlatformProps>,
  DatePickerDefinition
>()(
  viewerPropsMapper,
  { add: ['compPreviewState', 'shouldResetComponent', 'componentViewMode'] },
  (resolver, dependencies, carmiData) => {
    const viewerProps = resolver(dependencies, carmiData);
    const {
      shouldResetComponent,
      compPreviewState,
      componentViewMode,
      compProps,
    } = dependencies;

    return {
      ...viewerProps,
      previewWrapperProps: {
        shouldResetComponent,
        componentViewMode,
        compPreviewState,
        defaultTextType: compProps.defaultTextType,
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
